import { Action } from '@ngrx/store';
import * as models from '../../../../shared/model/api/models';

/**
 * SuperMenu Action Types
 */
export const WRITEUP_DETAIL_RIGHT_PANEL_ACTION = {
  CLICKED: '[Right Panel] CLICKED',
  WRITEUP_DETAIL_RESET: '[Right Panel] WRITEUP_DETAIL_RESET',
  TRADE_CLICKED: '[Trade Right Panel] CLICKED',
  CHAT_TAB_CLICKED:'[Trade Right Panel] CHAT_TAB_CLICKED',
  CHAT_TAB_CLICKED_SUCCESS:'[Trade Right Panel] CHAT_TAB_CLICKED_SUCCESS'
};
export const MONTHLY_TERMS_ACTION = {
    OPEN_DIALOG: '[Term message]  OPEN_DIALOG'
  };
export enum RightPanelItem{
    Display = 0,
    PriceGrid = 1,
    SellingPrice = 2,
    Accessories = 3,
    Discount = 33,
    Incentives = 4,
    TaxesAndFee = 5,
    AmountDue = 7,
    Trade = 6,
    SecurityDeposit = 8,
    Protection = 9,
    InstalledOptions = 10,
    Summary=11,
    ResidualValue=12,
    TotalTrade=13,
    Notes=14,
    Log=15,
    Signal=34
}
/**
 * Super Menu Clicked
 */
export class WriteupDetailRightPanelAction implements Action {
  public readonly type: string = WRITEUP_DETAIL_RIGHT_PANEL_ACTION.CLICKED;
  constructor(public payload?: RightPanelItem) {}
}

/**
 * Method used to Reset the dealer detail 
 */
export class WriteUpDetailRightPanelResetAction implements Action {
  public readonly type: string = WRITEUP_DETAIL_RIGHT_PANEL_ACTION.WRITEUP_DETAIL_RESET;
  constructor() {}
}

export class TradeDetailRightPanelAction implements Action {
  public readonly type: string = WRITEUP_DETAIL_RIGHT_PANEL_ACTION.TRADE_CLICKED;
  constructor(public payload?: number) {}
}


export class ChatTabClickRightPanelAction implements Action {
  public readonly type: string = WRITEUP_DETAIL_RIGHT_PANEL_ACTION.CHAT_TAB_CLICKED;
  constructor(public payload?: any) {}
}
export class ChatTabClickRightPanelSuccessAction implements Action {
  public readonly type: string = WRITEUP_DETAIL_RIGHT_PANEL_ACTION.CHAT_TAB_CLICKED_SUCCESS;
  constructor(public payload?: any) {}
}

export class MonthlyTermsChangedOpenPopup implements Action {
   public readonly type: string = MONTHLY_TERMS_ACTION.OPEN_DIALOG;
    constructor(public payload: any) {}
  }

export type Any = WriteupDetailRightPanelAction
| WriteUpDetailRightPanelResetAction | ChatTabClickRightPanelAction | ChatTabClickRightPanelSuccessAction | TradeDetailRightPanelAction | MonthlyTermsChangedOpenPopup;



                         
